module.exports = __webpack_public_path__ + "assets/videos/video-banner-poster.jpg?v=476a31ce";